import React from 'react'
import PropTypes from 'prop-types'

import JobHeader from './JobHeader'
import JobDescription from './JobDescription'
import JobAttachments from './JobAttachments'
import JobActions from './JobActions'

function JobInfo({ data = {
  lastMessage: {},
  offer: null,
  revenue: null,
  applicationId: null,
}, type }) {
  const jobHeaderStatus = type === 'in-progress' ? data.deadlineDate
    : data.type === 'initiated_by_buyer' ? 'Exclusive offer' : data.status
  const jobHeaderPrice = data.revenue ? { title: 'My revenue', value: data.revenue }
    : data.offer ? { title: 'My offer', value: data.offer } : null

  return (
    <div className="col-12 col-sm-5">
      <div className="jobs-info">
        <div className="jobs-info__contents">
          {(type !== 'available' || data.type === 'initiated_by_buyer')
            && (
            <JobHeader
              status={jobHeaderStatus}
              price={jobHeaderPrice}
            />
            )
          }

          {type === 'in-progress' ? (
            <JobDescription
              title="Last message"
              user={data.lastMessage.user}
              description={data.lastMessage.content}
            />
          ) : (
            <JobDescription
              title="Project description"
              description={data.description}
            />
          )}

          {data.attachments.length > 0
            && <JobAttachments attachments={data.attachments} slug={data.slug} status={type} type={data.type} />
          }

          <JobActions status={type} slug={data.slug} type={data.type} applicationId={data.applicationId} />
        </div>
      </div>
    </div>
  )
}

JobInfo.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    lastMessage: PropTypes.object,
    attachments: PropTypes.array.isRequired,
    offer: PropTypes.string,
    revenue: PropTypes.string,
    deadlineDate: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    applicationId: PropTypes.number,
  }).isRequired,
  type: PropTypes.string.isRequired,
}

export default JobInfo
